module.exports = __webpack_public_path__ + "static/media/amazon-dark-mode.9fcaf6f3.png";